<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Ficha de vacinação - Inconsistências"
    >
        <template v-if="data">
            <rkm-area
                title="Cadastro"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Profissional"
                            :value="data.cadastro.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.cadastro.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.cadastro.campos.cnes"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.cadastro.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="INE"
                            :value="data.cadastro.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.cadastro.campos.cboCodigo2002"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Data da aplicação"
                            :value="data.cadastro.campos.dataAtendimento"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.cadastro.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Vacinações individualizadas"
                type="fieldset"
            >
                <rkm-list
                    hide-pagination
                    hide-filters
                    :items="data.vacinacoes.lista"
                    class="p-0"
                >
                    <template v-slot="{ item }">
                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Paciente:</strong> {{ item.campos.nomeCidadao }}
                            </rkm-col>

                            <rkm-col>
                                <strong>CNS:</strong> {{ item.campos.cnsCidadao }}
                            </rkm-col>

                            <rkm-col>
                                <strong>Data de nascimento:</strong> {{ item.campos.dtNascimento }}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{ item }">
                        <div class="p-3">
                            <rkm-row>
                                <rkm-col cols="2">
                                    <Item
                                        label="Prontuário"
                                        :value="item.campos.numProntuario"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        label="CNS"
                                        :value="item.campos.cnsCidadao"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        label="CPF"
                                        :value="item.campos.cpfCidadao"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <Item
                                        label="Sexo"
                                        :value="item.campos.sexo"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <Item
                                        label="Data de nascimento"
                                        :value="item.campos.dtNascimento"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="2">
                                    <Item
                                        label="Turno"
                                        :value="item.campos.turno"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <Item
                                        label="Local de atendimento"
                                        :value="item.campos.localAtendimento"
                                    />
                                </rkm-col>

                                <rkm-col cols="1">
                                    <Item
                                        label="Viajante"
                                        :value="item.campos.viajante"
                                    />
                                </rkm-col>

                                <rkm-col cols="1">
                                    <Item
                                        label="Gestante"
                                        :value="item.campos.gestante"
                                    />
                                </rkm-col>

                                <rkm-col cols="1">
                                    <Item
                                        label="Puérpera"
                                        :value="item.campos.puerpera"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        label="Comunicante hanseníase"
                                        :value="item.campos.comunicanteHanseniase"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="6">
                                    <Item
                                        label="Data/hora inicial do atendimento"
                                        :value="item.campos.dataHoraInicialAtendimento"
                                    />
                                </rkm-col>

                                <rkm-col cols="6">
                                    <Item
                                        label="Data/hora final do atendimento"
                                        :value="item.campos.dataHoraFinalAtendimento"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-area
                                title="Vacinas"
                                type="fieldset"
                            >
                                <rkm-list
                                    hide-pagination
                                    hide-filters
                                    :items="item.campos.vacinas.lista"
                                    class="p-0"
                                >
                                    <template v-slot="{ item }">
                                        <rkm-row>
                                            <rkm-col cols="6">
                                                <strong>Imunobiológico:</strong> {{ item.campos.imunobiologico }}
                                            </rkm-col>
                                        </rkm-row>
                                    </template>

                                    <template v-slot:collapse="{ item }">
                                        <div class="p-3">
                                            <rkm-row>
                                                <rkm-col cols="4">
                                                    <Item
                                                        label="Imunobiológico"
                                                        :value="item.campos.imunobiologico"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        label="Estratégia"
                                                        :value="item.campos.estrategiaVacinacao"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <Item
                                                        label="Dose"
                                                        :value="item.campos.dose"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        label="Grupo de atendimento"
                                                        :value="item.campos.grupoAtendimento"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <rkm-row>
                                                <rkm-col cols="2">
                                                    <Item
                                                        label="Lote"
                                                        :value="item.campos.lote"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        label="Fabricante"
                                                        :value="item.campos.fabricante"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <Item
                                                        label="Registro Anterior"
                                                        :value="item.campos.stRegistroAnterior"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <Item
                                                        label="Aplicado exterior"
                                                        :value="item.campos.stAplicadoExterior"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        label="Data do registro anterior"
                                                        :value="item.campos.dataRegistroAnterior"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <Inconsistencia :inconsistencias="item.inconsistencias" />
                                        </div>
                                    </template>
                                </rkm-list>

                                <Inconsistencia :inconsistencias="item.campos.vacinas.inconsistencias" />
                            </rkm-area>

                            <Inconsistencia :inconsistencias="item.inconsistencias" />
                        </div>
                    </template>
                </rkm-list>

                <Inconsistencia :inconsistencias="data.vacinacoes.inconsistencias" />
            </rkm-area>
        </template>


        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error]
}
</script>